export const config = {
  maxPayments: 10,
  shareQuote:
    "הי, רציתי לספר לך על HoldOn, .חנות אינטרנטית עם מוצרים מעולים שעוזרים לי לנהל אורח חיים בריא יותר בקלות" +
    " לדעתי זה יכול לעניין אותך. " +
    " דרך הלינק הזה מקבלים 15% הנחה   ",
};
